// Data masking utility functions for sensitive information

/**
 * Masks an Aadhaar number, showing only the last 4 digits
 * Format: XXXX-XXXX-1234
 * @param {string} aadhaar - Aadhaar number (12 digits)
 * @returns {string} - Masked Aadhaar number
 */
export const maskAadhaar = (aadhaar) => {
  if (!aadhaar || aadhaar === 'N/A') return aadhaar || 'N/A';
  
  const cleaned = String(aadhaar).replace(/\D/g, ''); // Remove non-digits
  if (cleaned.length !== 12) return aadhaar; // Return original if invalid format
  
  // Show only last 4 digits: XXXX-XXXX-1234
  return `XXXX-XXXX-${cleaned.slice(-4)}`;
};

/**
 * Masks a PAN card number, showing only the last 4 characters
 * Format: XXXXX1234X
 * @param {string} pan - PAN card number (10 characters: 5 letters, 4 digits, 1 letter)
 * @returns {string} - Masked PAN card number
 */
export const maskPAN = (pan) => {
  if (!pan || pan === 'N/A') return pan || 'N/A';
  
  const cleaned = String(pan).toUpperCase().replace(/\s/g, ''); // Remove spaces and uppercase
  if (cleaned.length !== 10) return pan; // Return original if invalid format
  
  // Show only last 4 characters: XXXXX1234X
  return `XXXXX${cleaned.slice(-4)}`;
};

